(() => {
  let previousFocus = null;
  const motionButtons = () => document.querySelectorAll('[data-motion-toggle]');
  const closeDialog = dialog => {
    if (!dialog?.open) return;
    dialog.close();
    document.body.classList.remove('dialog-open');
    previousFocus?.focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-detail-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.detailOpen);
      if (!dialog || !dialog.showModal) return;
      event.preventDefault();
      previousFocus = opener;
      dialog.showModal();
      document.body.classList.add('dialog-open');
      return;
    }
    if (event.target.closest('[data-close],[data-close-link]')) {
      closeDialog(event.target.closest('dialog'));
      if (event.target.closest('[data-close-link]')) requestAnimationFrame(() => document.getElementById('WaitlistEmail')?.focus({ preventScroll: true }));
    }
    if (event.target.matches('dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog(event.target);
    }
    const toggle = event.target.closest('[data-motion-toggle]');
    if (toggle) {
      const paused = document.body.classList.toggle('motion-paused');
      motionButtons().forEach(button => {
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.resume : button.dataset.pause;
      });
    }
  });
  document.addEventListener('close', event => {
    if (event.target.tagName === 'DIALOG') {
      document.body.classList.remove('dialog-open');
      previousFocus?.focus({ preventScroll: true });
    }
  }, true);
  document.addEventListener('keydown', event => {
    const card = event.target.closest('.rail-item .product-card');
    if (!card || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    const cards = [...card.closest('.product-rail').querySelectorAll('.product-card')];
    const current = cards.indexOf(card);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + cards.length) % cards.length;
    event.preventDefault();
    cards[next].focus({ preventScroll: true });
    cards[next].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
  });
  const observeHero = () => {
    const hero = document.querySelector('.hero');
    if (!hero || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      hero.classList.toggle('is-offscreen', !entries[0].isIntersecting);
      hero.style.setProperty('--hero-visible', entries[0].isIntersecting ? 'running' : 'paused');
      const mark = hero.querySelector('.chrome-mark');
      if (mark) mark.style.animationPlayState = entries[0].isIntersecting && !document.hidden ? 'running' : 'paused';
    });
    observer.observe(hero);
  };
  document.addEventListener('visibilitychange', () => {
    document.body.classList.toggle('page-hidden', document.hidden);
    const mark = document.querySelector('.chrome-mark');
    if (mark) mark.style.animationPlayState = document.hidden ? 'paused' : 'running';
  });
  document.addEventListener('shopify:section:load', observeHero);
  observeHero();
})();
(() => {
  const ready=new WeakSet(),fine=matchMedia('(hover:hover) and (pointer:fine)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
  function setup(){document.querySelectorAll('[data-showroom]').forEach(scene=>{
    if(ready.has(scene))return;ready.add(scene);
    const grid=scene.querySelector('.showroom-grid'),pieces=[...scene.querySelectorAll('.showroom-piece')],jumps=[...scene.querySelectorAll('[data-showroom-jump]')];
    pieces.forEach(piece=>{
      const surface=piece.querySelector('.showroom-space'),front=piece.querySelector('.display-front'),back=piece.querySelector('.display-back');
      const dialog=document.getElementById(piece.dataset.detail);
      const colorButtons=[...piece.querySelectorAll('[data-showroom-color]')];
      const colorButton=color=>colorButtons.find(button=>button.dataset.showroomColor===color);
      const colorName=color=>colorButton(color)?.dataset.colorName||color;
      const asset=(view,color)=>colorButton(color)?.dataset[view]||(view==='front'?piece.dataset[color]:piece.dataset[color==='ink'?'backInk':'backBone']);
      const updateDialog=view=>{
        if(!dialog)return;const color=piece.dataset.color,label=colorName(color),photo=dialog.querySelector('.dialog-image img');
        photo.src=asset(view,color);photo.alt=`${piece.dataset.title} — ${label} ${view} view`;
        dialog.querySelector('.color-label').textContent=label;
        dialog.querySelectorAll('[data-detail-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.detailView===view)));
      };
      const setView=view=>{
        piece.dataset.view=view;
        front.setAttribute('aria-hidden',String(view!=='front'));back.setAttribute('aria-hidden',String(view!=='back'));
        piece.querySelectorAll('[data-showroom-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.showroomView===view)));
      };
      surface.addEventListener('pointerenter',event=>{if(fine.matches&&event.pointerType!=='touch')setView('front');});
      surface.addEventListener('pointerleave',()=>setView('back'));
      const face=piece.querySelector('.display-face');face.addEventListener('focus',()=>{if(face.matches(':focus-visible'))setView('front');});face.addEventListener('blur',()=>setView('back'));
      piece.querySelectorAll('[data-showroom-view]').forEach(b=>b.addEventListener('click',()=>setView(b.dataset.showroomView)));
      piece.querySelectorAll('[data-detail-open]').forEach(link=>link.addEventListener('click',()=>updateDialog(piece.dataset.view)));
      dialog?.querySelectorAll('[data-detail-view]').forEach(b=>b.addEventListener('click',()=>updateDialog(b.dataset.detailView)));
      let frame=0,x=0,y=0;
      const paint=()=>{frame=0;piece.style.setProperty('--look-x',`${x}deg`);piece.style.setProperty('--look-y',`${y}deg`);};
      surface.addEventListener('pointermove',event=>{
        if(!fine.matches||reduced.matches)return;
        const r=surface.getBoundingClientRect();x=Math.max(-3,Math.min(3,(event.clientX-r.left-r.width/2)/r.width*6));y=Math.max(-2,Math.min(2,-(event.clientY-r.top-r.height/2)/r.height*4));
        if(!frame)frame=requestAnimationFrame(paint);
      });
      surface.addEventListener('pointerleave',()=>{x=0;y=0;if(!frame)frame=requestAnimationFrame(paint);});
      // Warm all four angles/colors once the collection is near the viewport.
      const observer=new IntersectionObserver(entries=>{if(!entries.some(e=>e.isIntersecting))return;for(const color of colorButtons.map(button=>button.dataset.showroomColor))for(const view of ['front','back']){const preload=new Image();preload.src=asset(view,color);}observer.disconnect();},{rootMargin:'300px'});observer.observe(piece);
      piece.querySelectorAll('[data-showroom-color]').forEach(button=>button.addEventListener('click',()=>{
        const color=button.dataset.showroomColor,label=colorName(color);piece.dataset.color=color;
        front.src=asset('front',color);back.src=asset('back',color);
        front.alt=`${piece.dataset.title} — ${label} front view`;back.alt=`${piece.dataset.title} — ${label} back view`;
        piece.querySelector('[data-color-label]').textContent=label;
        piece.querySelectorAll('[data-showroom-color]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        updateDialog(piece.dataset.view);
      }));
      const unload=event=>{if(event.target.contains(scene)){observer.disconnect();if(frame)cancelAnimationFrame(frame);document.removeEventListener('shopify:section:unload',unload);}};document.addEventListener('shopify:section:unload',unload);
    });
    const jump=index=>grid.scrollTo({left:pieces[index].offsetLeft-(grid.clientWidth-pieces[index].offsetWidth)/2,behavior:reduced.matches?'auto':'smooth'});
    jumps.forEach((button,i)=>button.addEventListener('click',()=>jump(i)));
    let scrollFrame=0;
    grid.addEventListener('scroll',()=>{if(scrollFrame)return;scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;const center=grid.scrollLeft+grid.clientWidth/2;let closest=0;pieces.forEach((p,i)=>{if(Math.abs(p.offsetLeft+p.offsetWidth/2-center)<Math.abs(pieces[closest].offsetLeft+pieces[closest].offsetWidth/2-center))closest=i;});jumps.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===closest)));});},{passive:true});
    grid.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)||event.target.closest('.showroom-colors'))return;const current=pieces.indexOf(event.target.closest('.showroom-piece'));if(current<0)return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?pieces.length-1:Math.max(0,Math.min(pieces.length-1,current+(event.key==='ArrowRight'?1:-1)));jump(next);pieces[next].querySelector('.display-face').focus({preventScroll:true});});
  });}
  setup();document.addEventListener('shopify:section:load',setup);
  document.addEventListener('submit',event=>{if(!event.target.matches('[data-waitlist-preview]'))return;event.preventDefault();const status=event.target.querySelector('[data-preview-status]');status.hidden=false;status.focus();});
})();
